import {useQuery} from "@apollo/client";
import React from "react";
import {FieldErrors, FormProvider, useForm} from "react-hook-form";

import {TagsField} from "@/components/form/fields/TagsField/TagsField.tsx";
import FormErrorAlerts from "@/components/form/FormErrorAlerts.tsx";
import {ZENDESK_TAGS_ARTICLE} from "@/lib/constants/links.ts";
import {ServiceField} from "@/lib/constants/service.ts";
import {GQL_GET_SLA_REPORT_FORM_REQUIREMENTS, GetServiceTypesAndTagsResult} from "@/lib/queries/checks.ts";
import {ServerErrors} from "@/lib/types/common.ts";
import {EditCheckTagsFormValues} from "@/pages/checks/list/actions/bulkSetTags/BulkSetTagsModal.tsx";

export interface BulkSetTagsFormProps {
  formId: string;
  onSubmit: (data: EditCheckTagsFormValues) => void;
  onError?: (errors: FieldErrors<EditCheckTagsFormValues>, event?: React.BaseSyntheticEvent) => void;
  serverErrors?: ServerErrors;
}

export const BulkSetTagsForm = ({formId, onSubmit, onError, serverErrors}: BulkSetTagsFormProps) => {
  const {data, loading} = useQuery<GetServiceTypesAndTagsResult>(GQL_GET_SLA_REPORT_FORM_REQUIREMENTS);
  const currentData = loading ? {tags: [], monitoringServiceTypes: []} : data!;

  const methods = useForm<EditCheckTagsFormValues>({
    defaultValues: {
      tags: [],
    },
  });

  return (
    <FormProvider {...methods}>
      <form
        id={formId}
        onSubmit={(e) => {
          methods.handleSubmit(onSubmit, onError)(e);
        }}
      >
        {serverErrors?.schedule_entries && <FormErrorAlerts errors={serverErrors?.schedule_entries} />}
        <div className="row mb-4">
          <div className="col">
            Note: Existing tags on selected checks will be replaced with whatever you select below.
          </div>
        </div>
        <TagsField
          name={ServiceField.TAGS}
          label="Tags"
          helpText="Manage check tags."
          supportLink={ZENDESK_TAGS_ARTICLE}
          tags={currentData.tags}
          required={true}
          menuPortalTarget={
            (document.querySelector(`div.outlet-container > div.content-container`) as HTMLElement) ?? document.body
          }
          menuPosition={"fixed"}
        />
      </form>
    </FormProvider>
  );
};
